import * as React from 'react';
import { memo } from 'react';

var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgFlood = function SvgFlood(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 50 16 86.787V144l64-36.787V50Z",
    fill: "#E6F0F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 64.417c10.208 0 13.373-6.743 15.619-6.743 2.246 0 3.266 6.743 16.64 6.743 13.372 0 13.474-6.743 16.639-6.743 3.165 0 3.573 6.743 16.64 6.743 13.066 0 14.087-7.417 16.639-7.417 2.552 0 5.615 7.417 15.823 7.417M31 84.084c10.208 0 13.373-6.743 15.619-6.743 2.246 0 3.266 6.743 16.64 6.743 13.372 0 13.474-6.743 16.639-6.743 3.165 0 3.573 6.743 16.64 6.743 13.066 0 14.087-7.417 16.639-7.417 2.552 0 5.615 7.416 15.823 7.416M31 103.75c10.208 0 13.373-6.742 15.619-6.742 2.246 0 3.266 6.742 16.64 6.742 13.372 0 13.474-6.742 16.639-6.742 3.165 0 3.573 6.742 16.64 6.742 13.066 0 14.087-7.416 16.639-7.416 2.552 0 5.615 7.416 15.823 7.416",
    stroke: "#231F20",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var Memo = /*#__PURE__*/memo(SvgFlood);

export { Memo as default };
//# sourceMappingURL=flood.svg.js.map
